<template>
  <div id="app" class="fixed-header horizontal-menu horizontal-app-menu">
    <app-header v-if="isLoggedIn || notRequireLogin" :menuItems="menuItems"
      :notRequireLogin="notRequireLogin"></app-header>
    <div v-if="isLoggedIn || notRequireLogin" class="page-container" id="main-content">
      <div class="page-content-wrapper">
        <div class="content">
          <popup-new-features v-show="isLoggedIn" v-if="isManager"/>
          <version-outdated class="p-l-0 p-r-0"></version-outdated>
          <message class="p-l-0 p-r-0"></message>
          <div class="container container-fixed-lg container-main-data">
            <router-view class="p-b-15 p-t-5"/>
          </div>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import AppHeader from './components/common/AppHeader'
import AppFooter from './components/common/AppFooter'
import Message from './components/common/Message'
import VersionOutdated from './components/common/VersionOutdated'
import PopupNewFeatures from './components/common/PopupNewFeatures'
import { mapGetters } from 'vuex'
import { passwordRouters } from './settings/loginRouters'
import { checkRoleCandidate, checkRoleManager, checkRoleAdmin } from '@/helpers/roles'
import { userStatus } from './settings/users'

export default {
  name: 'app',
  components: { AppHeader, AppFooter, Message, VersionOutdated, PopupNewFeatures },
  methods: {
    getLinkByName(name) {
      return (this.$router.resolve({
        name: name,
        params: { entity_id: this.entityId }
      }).href)
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      currentUser: 'auth/currentUser'
    }),
    entityId() {
      return (this.currentUser.entities[0].id)
    },
    notRequireLogin() {
      return passwordRouters.includes(this.$route.name)
    },
    currentPath() {
      return this.$route.name
    },
    isCandidate() {
      return checkRoleCandidate(this.currentUser.role)
    },
    isManager() {
      return checkRoleManager(this.currentUser.role)
    },
    isAdmin() {
      return checkRoleAdmin(this.currentUser.role)
    },
    menuItems() {
      if (this.isAdmin) {
        return [
          { name: this.$i18n.t('tab.see_offers'), href: "/offers", active: this.currentPath=="Offers" },
          { name: this.$i18n.t('tab.create_offer'), href: this.getLinkByName("NewOffer"), active: this.currentPath=="NewOffer" },
          { name: this.$i18n.t('tab.manage_team'), href: this.getLinkByName("Users"), active: this.currentPath == "Users" },
          { name: this.$i18n.t('tab.stats'), href: this.getLinkByName("Stats"), active: this.currentPath == "Stats" },
          { name: this.$i18n.t('tab.parameters'), href: "",
            active: (this.currentPath == "Managers" || this.currentPath == "Services" || this.currentPath == "TimeCodes" || this.currentPath == "Occupations"),
            children: [
              {
                href: this.getLinkByName("Managers"),
                name: this.$i18n.t('tab.manage_managers')
              },
              {
                href: this.getLinkByName("Services"),
                name: this.$i18n.t('tab.manage_services')
              },
              {
                href: this.getLinkByName("TimeCodes"),
                name: this.$i18n.t('tab.manage_time_codes')
              },
              {
                href: this.getLinkByName("Occupations"),
                name: this.$i18n.t('tab.manage_occupations')
              }
            ]
          }
        ]
      } else if (this.isManager) {
        return [
          { name: this.$i18n.t('tab.see_offers'), href: "/offers", active: this.currentPath=="Offers" },
          { name: this.$i18n.t('tab.create_offer'), href: this.getLinkByName("NewOffer"), active: this.currentPath=="NewOffer" },
          { name: this.$i18n.t('tab.manage_team'), href: this.getLinkByName("Users"), active: this.currentPath == "Users" },
          { name: this.$i18n.t('tab.stats'), href: this.getLinkByName("Stats"), active: this.currentPath == "Stats" }
        ]
      } else if (this.isCandidate) {
        return [
          { name: this.$i18n.t('tab.see_offers'), href: "/", active: this.currentPath=="Dashboard" || this.currentPath=="Offers" },
          { name: this.$i18n.t('tab.unavailability_calendar'), href: this.getLinkByName("UnavailabilityCalendar"), active: this.currentPath=="UnavailabilityCalendar" }
        ]
      }
      return []
    }
  },
  beforeMount: function() {
    this.$store.dispatch('noData/disable');
  }
}
</script>

<style lang="scss">
  @import 'src/assets/scss/design.scss';
  @import 'vuejs-dialog/dist/vuejs-dialog.min.css';

  #app {
    height: 100%;
    display: flex;
    .content {
      padding-bottom: 200px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue